import { atom, useAtom, useSetAtom } from 'jotai';
import type { SocialProvider } from './socialAuth';

export type PendingSocialAuth = {
  provider: SocialProvider;
  /** provider access_token (apple은 id_token) */
  accessToken: string;
};

/**
 * 소셜 콜백(/auth/:provider)에서 확보한 provider 토큰을 Login 화면으로 넘기는
 * 단발 전역 아톰 (set → consume → clear). 웹 전용.
 *
 * - navigation param으로 넘기면 웹에서 비밀 토큰이 URL 쿼리스트링에 노출되므로
 *   jotai default store(SPA 전역)를 사용한다.
 * - AuthCallback이 navigator.moveToLogin(= navigation.replace, SPA 인메모리 이동)
 *   직전에 set하므로 풀 리로드 없이 Login 마운트까지 생존한다.
 */
export const pendingSocialAuthAtom = atom<PendingSocialAuth | null>(null);

/** AuthCallback: provider 토큰 확보 후 set */
export const useSetPendingSocialAuth = () => useSetAtom(pendingSocialAuthAtom);

/** Login: 마운트 시 읽고 소비 후 clear */
export const usePendingSocialAuth = () => useAtom(pendingSocialAuthAtom);

export type AlreadyRegisteredInfo = {
  /** 기가입 채널 (verify registered_member.channel, 예: 'KAKAO') */
  channel: string;
  email: string;
  hasMultiLoginType: boolean;
};

/**
 * 기가입 안내 화면(AlreadyRegistered)으로 넘길 정보.
 * email(PII)·channel을 URL(nav param) 대신 아톰으로 전달해 브라우저 히스토리·
 * 서버 로그·Referer 노출을 막는다. 복귀 경로(redirect)는 비밀이 아니므로 URL 유지.
 */
export const alreadyRegisteredAtom = atom<AlreadyRegisteredInfo | null>(null);

export const useSetAlreadyRegistered = () => useSetAtom(alreadyRegisteredAtom);
export const useAlreadyRegistered = () => useAtom(alreadyRegisteredAtom);
